import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { formValueSelector, reduxForm } from 'redux-form';
import { Button, Checkbox, Grid } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { LoadingPage } from 'Components';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { Filter, Main } from 'Containers';
import { resetForm } from 'State/forms/actions';
import { AdjustmentEnum } from 'Common/FieldEnum';
import { ADJUSTMENT_LIST_FORM_NAME } from 'Common/FormEnum';
import {
  GenericEnum,
  PrintSortTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import {
  ReactTableWrapperColumnProperties,
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { errorToast } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { dateSortMethod } from 'Common/GridHelper';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';

import { clearAdjustmentGridData } from '../../state/adjustmentList/actions';
import { actions } from '../../state/actions';
import AdjustmentListComponent from '../../components/adjustmentList/AdjustmentListComponent';
import { basicURL } from '../../helper';
import * as AdjustmentListSelectors from '../../state/adjustmentList/selectors';

import 'Styles/pages/inventory/transaction/adjustment/index.less';

class AdjustmentListContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    clearAdjustmentGridData: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    BeginDT: PropTypes.string,
    EndDT: PropTypes.string,
    site: PropTypes.string,
    printOptionsValue: PropTypes.string,
    initialValues: PropTypes.object.isRequired,
    allTableStates: PropTypes.object.isRequired,

    gridPreferenceData: PropTypes.object.isRequired,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    adjustmentListData: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    fetchingSites: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    selectedAdjustments: PropTypes.array.isRequired,
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    preferenceJsonError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    adjustmentListDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printLoadingError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fromDateMax: PropTypes.object,
    toDateMin: PropTypes.object,
  };

  static defaultProps = {
    BeginDT: moment()
      .subtract(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    EndDT: moment()
      .add(1, 'month')
      .format(DATE_FORMAT_FOR_UI),

    site: GenericEnum.ZeroString,
    printOptionsValue: AdjustmentEnum.PrintOptions,
    gridPreferenceSubmitError: null,
    preferenceJsonError: null,
    adjustmentListDataError: null,
    printLoadingError: null,
    fromDateMax: null,
    toDateMin: null,
  };
  constructor(props) {
    super(props);
    this.reactTableRef = React.createRef();
    this.state = {
      showUnsavedFiltersModal: false,
      selectedAdjustments: [],
      columns: [
        {
          Header: currentRows => {
            const { selectedAdjustments } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, obj => {
              const id = obj[AdjustmentEnum.TransactionId]
                ? obj[AdjustmentEnum.TransactionId]
                : obj._original[AdjustmentEnum.TransactionId];
              if (selectedAdjustments.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    e.stopPropagation();
                    if (checked) {
                      this.setState({
                        selectedAdjustments: [
                          ...this.state.selectedAdjustments,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedAdjustments];
                      _.forEach(dataObjs, obj => {
                        const id = obj[AdjustmentEnum.TransactionId]
                          ? obj[AdjustmentEnum.TransactionId]
                          : obj._original[AdjustmentEnum.TransactionId];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({ selectedAdjustments: copySelected });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: AdjustmentEnum.Allowed,
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            const { selectedAdjustments } = this.state;
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    selectedAdjustments.indexOf(
                      original[AdjustmentEnum.TransactionId]
                    ) !== -1
                  }
                  onChange={(e, { checked }) => {
                    this.checkCurrentRow(original, checked);
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Adjustment#',
          accessor: AdjustmentEnum.TransactionId,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Id',
          accessor: AdjustmentEnum.SiteId,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Name',
          accessor: AdjustmentEnum.SiteName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Adjust Dates',
          accessor: AdjustmentEnum.TransactionDT,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Status',
          accessor: AdjustmentEnum.Status,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Comments',
          accessor: AdjustmentEnum.Comments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(),
            });
          },
        },
      ],
    };
  }

  componentDidMount() {
    const { BeginDT, EndDT, site, initialValues } = this.props;

    const fetchData = {
      SiteId: site ? site : initialValues[AdjustmentEnum.Site],
      DateFrom: BeginDT
        ? moment(BeginDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .subtract(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      DateTo: EndDT
        ? moment(EndDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .add(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
    };
    this.props.getAdjustmentListData(fetchData);
  }

  componentDidUpdate(prevProps) {
    const { clearAdjustmentGridError } = this.props;
    if (
      errorToast(this.props, prevProps, 'printLoadingError') ||
      errorToast(this.props, prevProps, 'adjustmentListDataError')
    ) {
      clearAdjustmentGridError();
    }
  }

  componentWillUnmount() {
    this.props.clearAdjustmentGridData();
    this.clearTableSavedState();
    this.setState({ selectedAdjustments: [] });
    toast.dismiss();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.ADJUSTMENT_LIST_TABLE,
      TableNamesEnum.ADJUSTMENT_LIST_CREATE_EDIT_TABLE,
    ]);
  };

  getMenuOptions = () => {
    let checkCount = _.filter(
      this.props.adjustmentListData,
      AdjustmentEnum.Allowed
    );

    if (checkCount.length <= 1) {
      return [
        {
          icon: 'eye',
          text: 'View',
          handler: this.onViewClick,
        },
      ];
    }
    return [];
  };

  onViewClick = row => {
    this.props.history.push(`/adjustment/1/${row.TransactionId}`);
  };

  onAddClick = () => {
    this.props.history.push(`/adjustment/0/0`);
  };

  setSelectedSite = (newValue, prevValue) => {
    if (newValue !== prevValue) {
      const beginDT = this.props[AdjustmentEnum.BeginDT];
      const endDT = this.props[AdjustmentEnum.EndDT];

      if (beginDT && endDT) {
        const filtersOptions = {
          SiteId: newValue,
          DateFrom: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
          DateTo: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        };
        this.setState({ selectedAdjustments: [] });
        this.props.getAdjustmentListData(filtersOptions);
      }
    }
  };

  onChangeOfFromDT = (e, beginDate, prevBeginDate) => {
    beginDate !== prevBeginDate && this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate, prevEndDate) => {
    endDate !== prevEndDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    const endDT = this.props[AdjustmentEnum.EndDT];
    this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDate, endDT, this.props.site);
    this.setState({ selectedAdjustments: [] });
  };

  selectToDate = (e, endDate) => {
    const beginDT = this.props[AdjustmentEnum.BeginDT];
    this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDT, endDate, this.props.site);
    this.setState({ selectedAdjustments: [] });
  };

  clearFilters = () => {
    const { selectedAdjustments } = this.props;
    if (selectedAdjustments && selectedAdjustments.length) {
      this.setState({
        showUnsavedFiltersModal: true,
      });
    } else {
      this.handleClearFilters();
    }
  };

  handleClearFilters = () => {
    const { initialValues } = this.props;
    this.props.setFromDateMax(moment().add(1, 'month'));
    this.props.setToDateMin(moment().subtract(1, 'month'));
    this.setState({ selectedAdjustments: [] });
    this.getFilterData(
      initialValues[AdjustmentEnum.BeginDT],
      initialValues[AdjustmentEnum.EndDT],
      initialValues[AdjustmentEnum.Site]
    );
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(ADJUSTMENT_LIST_FORM_NAME);
  };

  getFilterData = (DateFrom, DateTo, Site) => {
    if (DateFrom && DateTo) {
      const filtersOptions = {
        SiteId: Site,
        DateFrom: moment(DateFrom).format(DATE_FORMAT_FOR_SERVER),
        DateTo: moment(DateTo).format(DATE_FORMAT_FOR_SERVER),
      };
      this.props.getAdjustmentListData(filtersOptions);
    }
  };

  printAdjustment = () => {
    const { adjustmentListData, printOptionsValue } = this.props;
    const beginDT = this.props[AdjustmentEnum.BeginDT];
    const endDT = this.props[AdjustmentEnum.EndDT];
    const checkedAdjustmentOrders = this.getFilteredSelectedAdjustment();
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: adjustmentListData };
    if (checkedAdjustmentOrders && !checkedAdjustmentOrders.length) {
      checkedAdjustmentOrders[0] =
        dataObjs.sortedData[0][AdjustmentEnum.TransactionId];
    }
    if (
      checkedAdjustmentOrders &&
      !checkedAdjustmentOrders.length &&
      adjustmentListData.length
    ) {
      checkedAdjustmentOrders[0] =
        adjustmentListData[0][AdjustmentEnum.TransactionId];
    }
    const DateFrom = moment(beginDT).format(DATE_FORMAT_FOR_SERVER);
    const DateTo = moment(endDT).format(DATE_FORMAT_FOR_SERVER);
    let sortType =
      printOptionsValue === AdjustmentEnum.ItemCode
        ? PrintSortTypeEnum.ItemCode
        : PrintSortTypeEnum.ItemDescription;

    checkedAdjustmentOrders.length &&
      this.props.getPrintAdjustmentData({
        DateFrom,
        DateTo,
        SortType: sortType,
        TransactionIds: checkedAdjustmentOrders,
      });
  };

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.setState({
        showUnsavedFiltersModal: false,
      });
      this.handleClearFilters();
    } else {
      this.setState({ showUnsavedFiltersModal: false });
    }
  }
  checkCurrentRow = (original, checked) => {
    let value = [...this.state.selectedAdjustments];
    checked
      ? value.indexOf(original[AdjustmentEnum.TransactionId]) === -1 &&
        value.push(original[AdjustmentEnum.TransactionId])
      : value.indexOf(original[AdjustmentEnum.TransactionId]) !== -1 &&
        value.splice(value.indexOf(original[AdjustmentEnum.TransactionId]), 1);

    this.setState({ selectedAdjustments: value });
  };
  getFilteredSelectedAdjustment = () => {
    const { adjustmentListData } = this.props;
    const { selectedAdjustments } = this.state;
    const checkedUsageOrders = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: adjustmentListData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[AdjustmentEnum.TransactionId]
        ? obj[AdjustmentEnum.TransactionId]
        : obj._original[AdjustmentEnum.TransactionId];
      if (selectedAdjustments.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  render() {
    const {
      adjustmentListData,
      printOptionsValue,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fetchingSites,
      loading,
      printLoading,
      fromDateMax,
      toDateMin,
    } = this.props;
    return printLoading ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Adjustment'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <AdjustmentListComponent
            columns={this.state.columns}
            setSelectedSite={this.setSelectedSite}
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            onChangeOfToDT={this.onChangeOfToDT}
            toDateMin={toDateMin}
            clearFilters={this.clearFilters}
            adjustmentListData={adjustmentListData}
            printOptionsValue={printOptionsValue}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            gridPreferenceLoading={gridPreferenceLoading}
            loading={loading}
            fetchingSites={fetchingSites}
            printAdjustment={this.printAdjustment}
            printLoading={printLoading}
            reactTableRef={this.reactTableRef}
          />
        </Main>
        <YesNoDialog
          showDialog={this.state.showUnsavedFiltersModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            this.handleUnsavedFilterDialog(true);
          }}
          noCallback={() => {
            this.handleUnsavedFilterDialog(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(ADJUSTMENT_LIST_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(ADJUSTMENT_LIST_FORM_NAME)(state));

  return {
    [AdjustmentEnum.BeginDT]: selector(state, AdjustmentEnum.BeginDT),
    [AdjustmentEnum.EndDT]: selector(state, AdjustmentEnum.EndDT),
    site: selector(state, AdjustmentEnum.Site),
    printOptionsValue: selector(state, AdjustmentEnum.PrintOptions),
    initialValues: {
      [AdjustmentEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [AdjustmentEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [AdjustmentEnum.Site]: GenericEnum.ZeroString,
      [AdjustmentEnum.PrintOptions]: AdjustmentEnum.ItemCode,
    },
    allTableStates: getTableStates(state),

    gridPreferenceData: GridPreferenceSelectors.getPreferenceJson(state),
    gridPreferenceSubmitError: GridPreferenceSelectors.getSubmitError(state),
    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),
    preferenceJsonError: GridPreferenceSelectors.getPreferenceJsonError(state),

    adjustmentListData: AdjustmentListSelectors.getAdjustmentListData(state),
    adjustmentListDataError: AdjustmentListSelectors.getAdjustmentListDataError(
      state
    ),
    loading: AdjustmentListSelectors.getLoading(state),
    fetchingSites: AdjustmentListSelectors.getFetchingSites(state),
    printLoading: AdjustmentListSelectors.getPrintLoading(state),
    selectedAdjustments: AdjustmentListSelectors.getSelectedAdjustments(state),
    printLoadingError: AdjustmentListSelectors.getPrintLoadingError(state),
    fromDateMax: AdjustmentListSelectors.getFromDateMax(state),
    toDateMin: AdjustmentListSelectors.getToDateMin(state),
  };
};

const mapDispatchToProps = {
  ...actions,
  resetForm,
  clearAdjustmentGridData,
  setTableStates,
};
AdjustmentListContainer = reduxForm({
  destroyOnUnmount: false,
  form: ADJUSTMENT_LIST_FORM_NAME,
})(AdjustmentListContainer);

export const Adjustment = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdjustmentListContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/containers/adjustmentList/AdjustmentListContainer.js